function centeringActiveTab(tab) {
  const tabList = document.querySelector(
    '[data-product-bundle-feedback-tabs-list]'
  );
  const offsetLeft =
    tab.offsetLeft + tab.offsetWidth / 2 - window.innerWidth / 2;

  tabList.scrollLeft = offsetLeft;
}

export const showActiveFeedback = () => {
  const ACTIVE_DATA_ATTR = 'data-active';
  const FEEDBACK_TAB_DATA_ATTR = 'data-product-bundle-feedback-tab';
  const FEEDBACK_PORTAL_DATA_ATTR = 'data-product-bundle-feedback-portal';
  const feedbackTabs = document.querySelectorAll(`[${FEEDBACK_TAB_DATA_ATTR}]`);
  const feedbackPortals = document.querySelectorAll(
    `[${FEEDBACK_PORTAL_DATA_ATTR}]`
  );

  feedbackTabs.forEach((feedbackTab, index) => {
    feedbackTab.addEventListener('click', () => {
      const activeFeedbackTab = document.querySelector(
        `[${FEEDBACK_TAB_DATA_ATTR}][${ACTIVE_DATA_ATTR}="true"]`
      );
      const activePortal = document.querySelector(
        `[${FEEDBACK_PORTAL_DATA_ATTR}][${ACTIVE_DATA_ATTR}="true"]`
      );

      activeFeedbackTab.setAttribute(ACTIVE_DATA_ATTR, 'false');
      activePortal.setAttribute(ACTIVE_DATA_ATTR, 'false');
      feedbackTab.setAttribute(ACTIVE_DATA_ATTR, 'true');
      feedbackPortals[index].setAttribute(ACTIVE_DATA_ATTR, 'true');

      centeringActiveTab(feedbackTab);
    });
  });
};
